// dont use any rtkQuery hook in this component as this renders on api error
// as well. In case the api breaks and you call the hook here, it will cause infinite loop.

import useRedirectToPage from '@/src/hooks/navigation/useRedirectToPage'
import { useTranslations } from 'next-intl'
import ErrorModal from './mandatoryAddonsModal'

const MandatoryAddonsModal = () => {
    const t = useTranslations('errorModal')
    const redirectToPage = useRedirectToPage()

    const primaryError = t("seatMealIncluded")
    const secondaryError = t("selectAncillaryForAll")
    const primaryButtonText = t("selectSeatAndMeal")
    const primaryButtonAction = () => redirectToPage({ pageName: 'addons', method: 'replace' })

    return (
        <ErrorModal
            isOpen={true}
            primaryError={primaryError}
            secondaryError={secondaryError}
            primaryButtonText={primaryButtonText}
            primaryButtonAction={primaryButtonAction}
        />
    )
}

export default MandatoryAddonsModal
